import axios from 'axios';

// For cPanel deployment, API is in /api/ folder on same domain
const API_BASE = '/api';

// Create axios instance with auth header
const api = axios.create({
  baseURL: API_BASE,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ganetov-token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API - PHP endpoints use .php extension and ?action= params
export const register = async (data) => {
  const response = await api.post('/auth.php?action=register', data);
  return response.data;
};

export const login = async (data) => {
  const response = await api.post('/auth.php?action=login', data);
  return response.data;
};

export const getMe = async () => {
  const response = await api.get('/auth.php?action=me');
  return response.data;
};

export const updateMe = async (data) => {
  const response = await api.put('/auth.php?action=me', data);
  return response.data;
};

// Registration with Email Verification
export const requestRegister = async (data) => {
  const response = await api.post('/auth.php?action=request-register', data);
  return response.data;
};

export const verifyRegister = async (email, code) => {
  const response = await api.post('/auth.php?action=verify-register', { email, code });
  return response.data;
};

// Password Reset API
export const forgotPassword = async (email) => {
  const response = await api.post('/auth.php?action=forgot-password', { email });
  return response.data;
};

export const resetPassword = async (email, code, new_password) => {
  const response = await api.post('/auth.php?action=reset-password', { email, code, new_password });
  return response.data;
};

// Products API
export const getProducts = async (includeInactive = false) => {
  const response = await api.get(`/products.php${includeInactive ? '?include_inactive=true' : ''}`);
  return response.data;
};

export const getProduct = async (productId) => {
  const response = await api.get(`/products.php?id=${productId}`);
  return response.data;
};

export const createProduct = async (data) => {
  const response = await api.post('/products.php', data);
  return response.data;
};

export const updateProduct = async (productId, data) => {
  const response = await api.put(`/products.php?id=${productId}`, data);
  return response.data;
};

export const deleteProduct = async (productId) => {
  const response = await api.delete(`/products.php?id=${productId}`);
  return response.data;
};

// Promo Code API
export const validatePromoCode = async (code) => {
  const response = await api.post('/promo.php?action=validate', { code });
  return response.data;
};

export const getPromoCodes = async () => {
  const response = await api.get('/promo.php');
  return response.data;
};

export const createPromoCode = async (data) => {
  const response = await api.post('/promo.php', data);
  return response.data;
};

export const updatePromoCode = async (promoId, data) => {
  const response = await api.put(`/promo.php?id=${promoId}`, data);
  return response.data;
};

export const deletePromoCode = async (promoId) => {
  const response = await api.delete(`/promo.php?id=${promoId}`);
  return response.data;
};

// Orders API
export const createOrder = async (orderData) => {
  const response = await api.post('/orders.php', orderData);
  return response.data;
};

export const getOrders = async (status = null) => {
  const response = await api.get(`/orders.php${status ? `?status=${status}` : ''}`);
  return response.data;
};

export const getMyOrders = async () => {
  const response = await api.get('/orders.php?action=my');
  return response.data;
};

export const getOrder = async (orderId) => {
  const response = await api.get(`/orders.php?id=${orderId}`);
  return response.data;
};

export const updateOrderStatus = async (orderId, status) => {
  const response = await api.put(`/orders.php?id=${orderId}&status=${status}`);
  return response.data;
};

export const deleteOrder = async (orderId) => {
  const response = await api.delete(`/orders.php?id=${orderId}`);
  return response.data;
};

// Admin Stats
export const getAdminStats = async () => {
  const response = await api.get('/stats.php');
  return response.data;
};

// Site Settings API
export const getSiteSettings = async () => {
  const response = await api.get('/settings.php');
  return response.data;
};

export const updateSiteSettings = async (data) => {
  const response = await api.put('/settings.php', data);
  return response.data;
};

// Upload Image API
export const uploadImage = async (file, category = 'general') => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('category', category);
  
  const response = await api.post('/upload.php', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export default api;
